(function () {
  'use strict';

  function initGallery(root) {
    if (root.dataset.pdpReady) return;
    root.dataset.pdpReady = '1';

    var track = root.querySelector('[data-pdp-track]');
    var dotsWrap = root.querySelector('[data-pdp-dots]');
    if (!track) return;

    var items = Array.prototype.slice.call(track.querySelectorAll('.pdp-gallery__item'));
    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.children) : [];
    var isMobile = function () { return window.matchMedia('(max-width: 768px)').matches; };

    /* ---- Update dots while swiping (mobile) ---- */
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (!isMobile() || !dots.length || ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        ticking = false;
      });
    }, { passive: true });

    /* ---- Scroll to the image of a given media id ---- */
    function goToMedia(mediaId) {
      var target = items.filter(function (el) {
        return String(el.getAttribute('data-media-id')) === String(mediaId);
      })[0];
      if (!target) return;

      if (isMobile()) {
        track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      } else {
        var y = target.getBoundingClientRect().top + window.pageYOffset - 20;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }

    /* ---- Variant sync ----
       Impulse updates the hidden <input name="id"> when a variant is chosen.
       We watch that value and look up the variant's featured media. */
    var jsonEl = root.parentNode.querySelector('[data-pdp-variants-json]') ||
                 document.querySelector('[data-pdp-variants-json]');
    if (!jsonEl) return;

    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    function currentVariantId() {
      var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      return input ? input.value : null;
    }
    var lastVariantId = currentVariantId();

    setInterval(function () {
      var id = currentVariantId();
      if (!id || id === lastVariantId) return;
      lastVariantId = id;
      var v = variants.filter(function (x) { return String(x.id) === String(id); })[0];
      if (v && v.media_id) goToMedia(v.media_id);
    }, 300);
  }

  function boot() {
    document.querySelectorAll('[data-pdp-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot); // theme editor support
})();